
import MergeOptionHandler from '~/fc/AdvacedSettings/MergeOptionHandler'
import { sortArrayByName, sortArrayByNameReverse } from "~/fc/Helpers/FormatHelpers"
import { loadScript } from "~/fc/Helpers/DOMHelper";

export default {
    name: "ThumbList",
    components: {
        Item: () => import(/* webpackChunkName: "ThumbListItem" */ "./ThumbListItem"),
        ImageViewer: () => import( /* webpackChunkName: "ImageViewer" */ "~/components/ui/ImageViewer")
    },
    props: {
        enableSort: {
            default: true
        }
    },
    data: () => ({
        galleryIndex: null,
        galleryLoading: false,
        images: [],
        sortedList: [],
        viewIndex: 0,
        pressTimer: false,
        initialMergeEnabled: false
    }),
    computed: {
        list() { return this.$store.state.list },
        info() { return this.$store.state.info },
        viewImage() { return this.list[this.viewIndex] },
        viewImgSrc() { return this.getUrl(this.viewImage) },
        fileInputConcurrentLength() { return this.$store.state.fileInputConcurrentLength },
        isMobile() { return this.$store.state.store.isMobile },
        isSafari() { return this.$store.state.store.isSafari },
        dragOptions () {
            return {
                animation: 150,
                forceFallback: this.isSafari
            }
        },
    },
    watch: {
        sortedList: {
            deep: true,
            immediate: false,
            handler(val) {
                this.$store.commit("setList", val);
            },
        },
        list: {
            immediate: true,
            async handler(val) {
                this.sortedList = val
                this.images = JSON.parse(JSON.stringify(this.list))

                if (this.fileInputConcurrentLength > 1 && !this.initialMergeEnabled) {
                    await this.wait(250)
                    new MergeOptionHandler().setMerge(true)
                    this.initialMergeEnabled = true
                } else if (this.fileInputConcurrentLength === 1) {
                    await this.wait(250)
                    if (this.info.toolPage) {
                        new MergeOptionHandler().setMerge(true)
                    }
                    new MergeOptionHandler().setMerge(false)
                }
            },
        },
    },
    mounted() {
        if(process.client) {
            this.$bus.$on("SORT_FILES_ALPHABETICALLY", this.sortArrayByName)
            this.$bus.$on("SORT_FILES_ALPHABETICALLY_REVERSE", this.sortArrayByNameReverse)
            this.loadSortable()
            this.$store.commit('advancedSetting/setSelectedPreviewItem', this.list[0].id)
        }
    },
    destroyed() {
        this.removeSkippedFiles()
    },
    methods: {
        wait(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        sortArrayByNameReverse() {
            this.sortedList = sortArrayByNameReverse([...this.sortedList]);
        },
        sortArrayByName() {
            this.sortedList = sortArrayByName([...this.sortedList]);
        },
        getUrl(viewImage) {
            if (!viewImage) return new Blob();
            if (viewImage.file === "url") {
                return viewImage.src;
            }
            return URL.createObjectURL(viewImage.file);
        },
        zoomFile(e) {
            this.viewIndex = e;
            this.$refs.ImageViewer.open();
        },
        moveObjectInArray (array, oldIndex, newIndex) {
            if (oldIndex < 0 || oldIndex >= array.length || newIndex < 0 || newIndex >= array.length) return array;
            const newArray = [...array];
            const [removedObject] = newArray.splice(oldIndex, 1);
            newArray.splice(newIndex, 0, removedObject);
            return newArray;
        },
        loadSortable() {
            const self = this
            loadScript(
                "https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.14.0/Sortable.min.js",
                "sortable", 
                () => {
                    new Sortable(
                        thumbList, 
                        {
                            animation: 150,
                            forceFallback: self.isSafari,
                            onSort: ({oldIndex, newIndex}) => {
                                self.sortedList = self.moveObjectInArray(self.sortedList, oldIndex, newIndex)
                            }
                        }
                    );
                }
            );
        },
        removeSkippedFiles() {
            this.$store.commit('removeSkippedFiles')
        }
    }
};
